import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Col } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../../i18next';
import AvInput from 'availity-reactstrap-validation/lib/AvInput';

class ImportAdditionalChargesFromCSVModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            additionalChargesCSV: null
        }

        this.onChange = this.onChange.bind(this);
    }

    onChange({ target }) {
        this.setState({ ...this.state, [target.name]: target.files[0] });
    }

    submitForm() {
       
    }

    render() {
        const restaurantId = this.props.restaurant.id;
        
        return (
            <Modal className='importAdditionalChargesModal' isOpen={this.props.isOpen} toggle={() => this.props.toggle(true)}>
                <AvForm onValidSubmit={() => this.props.importAdditionalChargesFromCSV(restaurantId, this.state.additionalChargesCSV)}>
                    <ModalHeader className="modalHeader" toggle={() => this.props.toggle(true)} style={{ margin: 'auto' }}>
                        {i18n.t('screens:paymentScreen.importAdditionalCharges')}
                    </ModalHeader>
                    <ModalBody>
                        <AvGroup row style={{textAlign: 'center'}}>
                            <Label sm={5} style={{paddingTop: '0px'}}>{i18n.t(`screens:paymentScreen.additionalChargesCSV`)}</Label>
                            <Col sm={7}>
                                <AvInput 
                                    type="file" 
                                    name="additionalChargesCSV" 
                                    id="additionalChargesCSV" 
                                    onChange={this.onChange} 
                                    required={true} 
                                    style={{overflow: 'hidden'}} />
                                <AvFeedback style={{textAlign: 'left'}}>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                            </Col>
                        </AvGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary">
                            <span>
                                <span style={{marginRight: '5px'}}><MaterialIcon icon="cloud_download" color="#fff" size={19} /></span>
                                <span>{i18n.t('screens:menuConfigScreen.import')}</span>
                            </span>
                        </Button>
                    </ModalFooter>
                </AvForm>
            </Modal>
        );
    }
}

export default ImportAdditionalChargesFromCSVModal;


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/menuuBilling/ImportAdditonalChargesFromCSVModal.js